import { useState, memo } from "react";
import {
  Button,
  MenuItem,
  Menu,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ExportMenu from "./ExportMenu";
import QuickStatus from "./QuickStatus";
import ColumnsMenu from "./ColumnsMenu";
import CheckFiltersMenu from "./CheckFiltersMenu";
import { useMainContext } from "../../../../../context/useMainContext";
import Conditional from "./Conditional";

const DotsMenu = ({
  setAnchorExportEl,
  isDotsMenuOpen,
  setIsDotsMenuOpen,
  anchorExportEl
}) => {
  const {
    showOnlyApproved,
    setShowOnlyApproved,
  } = useMainContext();

  const [columnAnchorEl, setColumnAnchorEl] = useState(null);
  const [checkAnchorEl, setCheckAnchorEl] = useState(null);
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const [conditionalDrawerOpen, setConditionalDrawerOpen] = useState(false);
  const openDots = Boolean(isDotsMenuOpen);

  const handleCloseDots = () => setIsDotsMenuOpen(null);
  const handleCloseConditional = () => setConditionalDrawerOpen(false);

  return (
    <>
      <Button
        variant="outlined"
        onClick={(e) => setIsDotsMenuOpen(e.currentTarget)}
        aria-haspopup="true"
        aria-expanded={openDots ? "true" : undefined}
        sx={{ px: 1 }}
      >
        <MoreHorizIcon />
      </Button>

      <Menu
        anchorEl={isDotsMenuOpen}
        open={openDots}
        onClose={handleCloseDots}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={(e) => setColumnAnchorEl(e.currentTarget)}>
          Columns
        </MenuItem>
        <MenuItem onClick={(e) => setStatusAnchorEl(e.currentTarget)}>
          Quick Status
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleCloseDots();
            setShowOnlyApproved((prev) => !prev);
          }}
        >
          {showOnlyApproved ? "Show All" : "Show Approved"}
        </MenuItem>
        <MenuItem onClick={(e) => setCheckAnchorEl(e.currentTarget)}>
          Check Filters
        </MenuItem>
        <MenuItem onClick={() => {
          setConditionalDrawerOpen(true);
          handleCloseDots();
        }}>
          Conditional
        </MenuItem>
        <MenuItem onClick={(e) => setAnchorExportEl(e.currentTarget)}>
          Export
        </MenuItem>
      </Menu>

      <ColumnsMenu
        {...{
          columnAnchorEl,
          setColumnAnchorEl,
          handleCloseDots,
        }}
      />

      <QuickStatus
        {...{
          statusAnchorEl,
          setStatusAnchorEl,
          handleCloseDots,
        }}
      />

      <CheckFiltersMenu
        {...{
          checkAnchorEl,
          setCheckAnchorEl,
          handleCloseDots,
        }}
      />

      <Conditional
        {...{
          conditionalDrawerOpen,
          handleCloseConditional,
        }}
      />

      <ExportMenu
        {...{
          anchorExportEl,
          setAnchorExportEl,
          setIsDotsMenuOpen,
        }}
      />
    </>
  );
};

export default memo(DotsMenu);
